import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(
    private keycloak: Keycloak,
  ) { }

  logout() {
    this.keycloak.logout();
    localStorage.removeItem('ht-kiosk-store');
  }

}
